import React from 'react';

// constants
import { DASHBOARD_TOOLBAR_TITLE} from "./constants";

// redux
import withShipment from "../../withShipment";
import {userInfoSelector} from "../../redux/selectors/auth";


import DateFnsUtils from "@date-io/date-fns";
import {MuiPickersUtilsProvider} from "@material-ui/pickers";


import ErrorFeedbackBar from '../global/ErrorFeedbackBar';

import CustomToolbar from "../global/CustomToolbar";
import RefreshIcon from "@material-ui/icons/Refresh";
import { HourglassEmptyTwoTone} from "@material-ui/icons";
import {refreshSelector} from "../../redux/selectors/dashboard";
import {DASHBOARD as DASHBOARD_ENDPOINTS} from "../global/Server/endpoints";
import {apiRequest} from "../../redux/actions/api";
import './Dashboard.responsive.css';



class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cardsData: [],
      dashboardCards: [],
    };
  };

  componentDidMount() {
    this.refreshComponent();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {

    if (prevProps.refresh !== this.props.refresh) {
      this.refreshComponent();
    }

  }

  fetchDashboardFolders = () => {
    // Routed through the generic api saga (Redux Saga + AuthUtil) instead
    // of a direct axios.post. The saga handles the bearer token, the
    // 401/403 → /login bounce, and pushes any error into the global
    // ErrorFeedbackBar automatically.
    this.props.apiRequest({
      key: 'dashboard/folders',
      endpoint: DASHBOARD_ENDPOINTS.LIST_FOLDERS,
      data: { companyId: this.props.userInfo.company },
      onSuccess: (payload) => {
        if (!payload || !Array.isArray(payload.data)) return;

        // Defensive: `authority` may be a string, array, missing, or null
        // depending on how the user was created. Same for `selectedFolders`.
        const authority = this.props.userInfo?.authority;
        const isAdmin =
          (typeof authority === 'string' && authority === 'ROLE_ADMIN') ||
          (Array.isArray(authority) && authority.includes('ROLE_ADMIN'));

        let folderCard;
        if (isAdmin) {
          folderCard = payload.data;
        } else {
          const selectedFolders = Array.isArray(this.props.userInfo?.selectedFolders)
            ? this.props.userInfo.selectedFolders
            : [];
          folderCard = payload.data.filter((card) =>
            selectedFolders.includes(card.dashboardFolderId),
          );
        }

        this.setState({ dashboardCards: payload.data, cardsData: folderCard });
      },
    });
  };


  refreshComponent = () => {
    this.fetchDashboardFolders();
  };


  render() {


    let headerButtons = [];

      headerButtons.push({
        icon: this.props.refreshing ? <HourglassEmptyTwoTone /> : <RefreshIcon />,
        handler: this.refreshComponent,
        title: this.props.refreshing ? 'Refreshing...' : 'Refresh',
        disabled: this.props.refreshing,
      });


    return (
      <>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <ErrorFeedbackBar />
          <CustomToolbar
            title={DASHBOARD_TOOLBAR_TITLE}
            createTitle={'Dashboard'}
            backTitle={'Back To Menu'}
            onClick={() => {}}
            headerButtons={headerButtons}
          />
        </MuiPickersUtilsProvider>

        <div className="bn-dashboard">
          {this.state.cardsData.length === 0 ? (
            <div className="bn-dashboard-empty">
              <span
                className="bn-dashboard-empty-icon"
                role="img"
                aria-label="Empty folder"
              >
                📁
              </span>
              <div className="bn-dashboard-empty-title">No folders yet</div>
              <div className="bn-dashboard-empty-sub">
                Folders you have access to will appear here.
              </div>
            </div>
          ) : (
            <div className="bn-dashboard-grid">
              {this.state.cardsData.map((card, index) => (
                <div
                  className="bn-dashboard-card"
                  key={card.dashboardFolderId || index}
                  onClick={() =>
                    this.props.history.push({
                      pathname: '/file-manager',
                      state: {
                        selectedFolder: card.title,
                        parentId: card.dashboardFolderId,
                      },
                    })
                  }
                >
                  <div className="bn-dashboard-card-media">
                    {card.imageUrl ? (
                      <img
                        src={card.imageUrl}
                        alt={card.title}
                      />
                    ) : (
                      <span
                        className="bn-dashboard-card-placeholder"
                        role="img"
                        aria-label="Folder"
                      >
                        📁
                      </span>
                    )}
                  </div>
                  <div className="bn-dashboard-card-body">
                    <div className="bn-dashboard-card-title">{card.title}</div>
                    <div className="bn-dashboard-card-arrow">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                           stroke="currentColor" strokeWidth="2.5"
                           strokeLinecap="round" strokeLinejoin="round">
                        <path d="M9 18l6-6-6-6" />
                      </svg>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

      </>
    )
  }
}

const mapStateToProps = (state) => ({
  userInfo: userInfoSelector(state),
  refresh: refreshSelector(state),
});

const actionCreators = {
  apiRequest,
}


Dashboard.propTypes = {

}

Dashboard.defaultProps = {

}

export default withShipment({
  mapStateToProps,
  actionCreators
}, Dashboard);